export const getLinkProps = (href?: string) => {
  const target =
    href?.startsWith('/') || href?.includes('zapier.com')
      ? undefined
      : '_blank';
  const rel = target === '_blank' ? 'noopener' : undefined;
  return { target, rel };
};
